<i18n>
    {
        cn: {
            allNews: '全部新闻',
        },
        en: {
            allNews: 'All News',
        }
    }
</i18n>
<script>
import { mapState } from 'vuex';
import ContactForm from '../../components/contactForm.vue'
import NewsSwiperList from '../../components/newsSwiperList.vue';

export default {
    name: "newsList",
    data() {
        return {
            menuActiveIndex: 0,
        };
    },
    computed: {
        ...mapState(['newsData']),
    },
    components: {
        ContactForm,
        NewsSwiperList
    },
    mounted() {
        // 
        this.$store.dispatch('getNewsData').then((result) => {
            if (result.code == 100) { 
                // 滚动监听
                window.addEventListener('scroll', this.handleScroll);
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {
        // 删除 - 滚动监听
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {},
    methods: {
        // 滚动监听
        handleScroll() { 
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const menuHeight = this.$refs.menu.clientHeight;
            let index = this.newsData.list.findLastIndex((v, i) => {
                return scrollTop >= this.$refs.list[i].offsetTop - menuHeight;
            });
            this.menuActiveIndex = index + 1;
        },
        menuTap(index) { 
            let offsetTop = this.$refs.list[index].offsetTop;
            const menuHeight = this.$refs.menu.clientHeight;
            window.scrollTo({
                top: offsetTop - menuHeight,
                behavior: "smooth",
            });
        },
        toTop() {
            this.menuActiveIndex = 0;
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    },
};
</script>

<template>
    <div class="news_list">
        <div class="wrapper layout_main">
            <!--  -->
            <div class="menu flex" ref="menu">
                <div class="item" :class="{active: menuActiveIndex == 0}" @click="toTop">{{ $t('allNews') }}</div>
                <div class="item" v-for="(item, index) in newsData.list" :key="index"
                :class="{active: menuActiveIndex == index + 1}" 
                @click="menuTap(index)">{{ item.name }}</div>
            </div>
            <!-- 置顶 -->
            <div class="content top flex only_pc" v-if="newsData.top_news.length > 0">
                <router-link class="item" v-for="(item, index) in newsData.top_news" :key="index" :to="`/news/detail?id=${item.id}`">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <div class="name">{{ item.name }}</div>
                </router-link>
            </div>
            <div class="content only_mobile" v-if="newsData.top_news.length > 0">
                <NewsSwiperList :data="newsData.top_news"/>
            </div>
            <!-- 公司新闻 -->
            <div class="content" ref="list" v-for="(item, index) in newsData.list" :key="index">
                <div class="title"><span>{{ item.name }}</span></div>
                <NewsSwiperList v-if="item.news.length > 0" :data="item.news"/>
                <p class="no_more" v-else>{{ $t('noMore') }}</p>
            </div>
        </div>
        <ContactForm from="新闻"/>
    </div>
</template>

<style scoped lang="scss">
.news_list{
    .content{
        margin-bottom: .5rem;
        .title{
            font-size: .25rem;
            padding: 0 .4rem;
            margin-bottom: .3rem;
            span{
                border-bottom: 1px solid var(--font_color);
            }
            @media only screen and (max-width: 750px) {
                padding: 0;
                font-size: .32rem;
                text-align: center;
                span{
                    border-bottom: none;
                }
            }
        }
    }
}
.menu{
    gap: .3rem;
    padding: .2rem .4rem;
    position: sticky;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 2;
    .item{
        font-size: .18rem;
        color: #999;
        cursor: pointer;
        border-bottom: 1px solid transparent;
        &:hover,
        &.active{
            color: var(--font_color);
            border-color: var(--font_color);
        }
    }
    @media only screen and (max-width: 750px) {
        width: 7.5rem;
        margin: 0 -.3rem;
        padding: 0;
        top: 1.6rem;
        padding: 0 .3rem;
        overflow: hidden;
        overflow-x: scroll;
        gap: .8rem;
        border-bottom: 1px solid #999;
        .item{
            line-height: .9rem;
            font-size: .25rem;
            white-space: nowrap;
            border-bottom: none;
        }
    }
}
.top{
    padding: 0 .4rem;
    gap: .6rem;
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
    .item{
        flex: 1;
        .bg{
            height: 3.4rem;
            // padding-bottom: 64.15%;
            margin-bottom: .15rem;
            // 
            // border: 1px solid #000;
        }
        .name{
            font-size: .2rem;
            text-align: center;
        }
    }
}
</style>